/* ═══════════════════════════════════════════════════
   Taglio Studio — Shopify Theme JavaScript
   Handles: header scroll, mobile menu, search overlay,
   carousels, scroll reveal animations, back-to-top
   ═══════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── HEADER SCROLL BEHAVIOR ─── */
  const header = document.querySelector('.header');
  if (header) {
    const heroPages = ['/', '/pages/quem-somos', '/pages/sob-medida', '/pages/sustentabilidade'];
    const currentPath = window.location.pathname;
    const isHeroPage = heroPages.some(p => currentPath === p || currentPath.endsWith(p));

    function updateHeader() {
      const scrolled = window.scrollY > 40;
      if (scrolled) {
        header.classList.remove('header--transparent');
        header.classList.add('header--scrolled');
      } else if (isHeroPage) {
        header.classList.remove('header--scrolled');
        header.classList.add('header--transparent');
      }
    }

    if (isHeroPage) {
      header.classList.add('header--transparent');
    } else {
      header.classList.remove('header--transparent');
      header.classList.add('header--scrolled');
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  }

  /* ─── MOBILE MENU ─── */
  const mobileBtn = document.querySelector('.header__mobile-btn');
  const mobileMenu = document.querySelector('.mobile-menu');
  const menuIcon = document.querySelector('.header__menu-icon');
  const closeIcon = document.querySelector('.header__close-icon');

  if (mobileBtn && mobileMenu) {
    mobileBtn.addEventListener('click', function () {
      const isOpen = mobileMenu.classList.contains('mobile-menu--open');
      if (isOpen) {
        mobileMenu.classList.remove('mobile-menu--open');
        if (menuIcon) menuIcon.style.display = '';
        if (closeIcon) closeIcon.style.display = 'none';
      } else {
        mobileMenu.classList.add('mobile-menu--open');
        if (menuIcon) menuIcon.style.display = 'none';
        if (closeIcon) closeIcon.style.display = '';
      }
    });

    // Close on link click
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('mobile-menu--open');
        if (menuIcon) menuIcon.style.display = '';
        if (closeIcon) closeIcon.style.display = 'none';
      });
    });
  }

  /* ─── SEARCH OVERLAY ─── */
  var searchOverlay = document.getElementById('search-overlay');
  var searchInput = document.getElementById('search-input');
  var searchGrid = document.getElementById('search-grid');
  var searchEmpty = document.getElementById('search-empty');
  var searchNoResults = document.getElementById('search-no-results');
  var searchDebounce = null;

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('search-overlay--open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Close mobile menu if open
    if (mobileMenu && mobileMenu.classList.contains('mobile-menu--open')) {
      mobileMenu.classList.remove('mobile-menu--open');
      if (menuIcon) menuIcon.style.display = '';
      if (closeIcon) closeIcon.style.display = 'none';
    }
    setTimeout(function () {
      if (searchInput) searchInput.focus();
    }, 200);
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('search-overlay--open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (searchInput) searchInput.value = '';
    if (searchGrid) { searchGrid.style.display = 'none'; searchGrid.innerHTML = ''; }
    if (searchEmpty) searchEmpty.style.display = '';
    if (searchNoResults) searchNoResults.style.display = 'none';
  }

  // Open buttons
  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', openSearch);
  });

  // Close buttons and backdrop
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', closeSearch);
  });

  // ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('search-overlay--open')) {
      closeSearch();
    }
  });

  // Predictive search
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var query = this.value.trim();
      clearTimeout(searchDebounce);

      if (query.length < 2) {
        if (searchGrid) { searchGrid.style.display = 'none'; searchGrid.innerHTML = ''; }
        if (searchEmpty) searchEmpty.style.display = '';
        if (searchNoResults) searchNoResults.style.display = 'none';
        return;
      }

      searchDebounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=12')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];

            if (searchEmpty) searchEmpty.style.display = 'none';

            if (products.length === 0) {
              if (searchGrid) { searchGrid.style.display = 'none'; searchGrid.innerHTML = ''; }
              if (searchNoResults) searchNoResults.style.display = '';
              return;
            }

            if (searchNoResults) searchNoResults.style.display = 'none';

            var html = '';
            products.forEach(function (p) {
              var imgSrc = p.image || '';
              var price = p.price ? ('R$ ' + (parseFloat(p.price) / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 })) : '';
              html += '<a href="' + p.url + '" class="search-result-card">';
              html += '<div class="search-result-card__img">';
              if (imgSrc) {
                html += '<img src="' + imgSrc + '" alt="' + p.title + '" loading="lazy" />';
              }
              html += '</div>';
              html += '<div class="search-result-card__info">';
              html += '<h4>' + p.title + '</h4>';
              if (price) html += '<p class="search-result-card__price">' + price + '</p>';
              html += '</div>';
              html += '</a>';
            });

            if (searchGrid) {
              searchGrid.innerHTML = html;
              searchGrid.style.display = '';
            }
          })
          .catch(function () {
            // Fallback: redirect to search page
          });
      }, 300);
    });
  }

  /* ─── SCROLL REVEAL (Intersection Observer) ─── */
  const revealElements = document.querySelectorAll('.reveal');
  if (revealElements.length > 0 && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    revealElements.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ─── CAROUSEL SCROLL ─── */
  document.querySelectorAll('[data-carousel]').forEach(function (wrapper) {
    const carousel = wrapper.querySelector('[data-carousel-track]');
    const prevBtn = wrapper.querySelector('[data-carousel-prev]');
    const nextBtn = wrapper.querySelector('[data-carousel-next]');

    if (carousel && prevBtn && nextBtn) {
      // Thumbnail carousels use smaller scroll amount; others use 340
      const isThumbs = wrapper.classList.contains('pdp-thumbs');
      const scrollAmount = isThumbs ? 80 : 340;

      prevBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  });

  /* ─── CATEGORY TABS ─── */
  document.querySelectorAll('[data-tab-group]').forEach(function (group) {
    const tabs = group.querySelectorAll('[data-tab]');
    const panels = document.querySelectorAll('[data-tab-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const target = this.getAttribute('data-tab');

        // Update active tab
        tabs.forEach(function (t) {
          t.classList.remove('tab-pill-active');
        });
        this.classList.add('tab-pill-active');

        // Show/hide panels
        panels.forEach(function (panel) {
          const panelCategory = panel.getAttribute('data-tab-panel');
          if (target === 'todos' || panelCategory === target) {
            panel.style.display = '';
          } else {
            panel.style.display = 'none';
          }
        });
      });
    });
  });

  /* ─── ACCORDION / BENEFITS ─── */
  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    const items = accordion.querySelectorAll('[data-accordion-item]');

    items.forEach(function (item, index) {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const content = item.querySelector('[data-accordion-content]');

      // Show first item by default
      if (index === 0) {
        item.classList.add('active');
        if (content) content.style.display = '';
      } else {
        if (content) content.style.display = 'none';
      }

      if (trigger) {
        trigger.addEventListener('click', function () {
          // Close all
          items.forEach(function (i) {
            i.classList.remove('active');
            i.style.opacity = '0.4';
            const c = i.querySelector('[data-accordion-content]');
            if (c) c.style.display = 'none';
          });

          // Open clicked
          item.classList.add('active');
          item.style.opacity = '1';
          if (content) content.style.display = '';
        });
      }
    });
  });

  /* ─── PRODUCT IMAGE GALLERY ─── */
  const mainImage = document.querySelector('[data-main-image]');
  const thumbs = document.querySelectorAll('[data-thumb]');

  if (mainImage && thumbs.length > 0) {
    var currentIndex = 0;

    function goToImage(index) {
      if (index < 0) index = thumbs.length - 1;
      if (index >= thumbs.length) index = 0;
      currentIndex = index;
      thumbs[currentIndex].click();
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        currentIndex = i;
        const src = this.getAttribute('data-thumb-src');
        const isLifestyle = this.hasAttribute('data-lifestyle');

        mainImage.src = src;
        mainImage.style.objectFit = isLifestyle ? 'cover' : 'contain';
        mainImage.style.padding = isLifestyle ? '0' : '1rem';

        // Update active state
        thumbs.forEach(function (t) {
          t.classList.remove('pdp-thumb--active');
        });
        this.classList.add('pdp-thumb--active');
      });
    });

    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goToImage(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToImage(currentIndex + 1); });
  }

  /* ─── BACK TO TOP ─── */
  const backToTop = document.querySelector('.back-to-top');
  if (backToTop) {
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ─── NEWSLETTER FORM ─── */
  /* Forms use native Shopify {% form 'customer' %} submission */

});
